module.exports = __webpack_public_path__ + "static/img/top-bg.127d491.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/top-bg.png
// module id = 81Wb
// module chunks = 0